import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import * as colors from '../../shared/colors';
import NoteIcon from '../../shared/components/icons/NoteIcon';
import t from '../../shared/translations';
import { ISubmittedTask } from './query';

interface IProps {
    task: ISubmittedTask;
}

const Tabs = styled.nav`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 1rem;
    border-bottom: 2px solid ${colors.primaryColor};
`;

const tabStyle = css`
    padding: 0.5rem 0.9rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    text-decoration: none;
    border-width: 2px;
    border-bottom-width: 0;
    border-style: solid;
    border-color: ${colors.primaryColor};
    color: ${colors.primaryColor};
    background-color: white;

    &:hover, &:focus, &:active, &:visited {
        color: ${colors.primaryColor};
    }
`;

interface ITab {
    $current?: boolean;
}

const LinkTab = styled(NavLink) <ITab>`
    ${tabStyle}
    svg {
        width: 32px;
        height: 32px;
        margin-bottom: -14px;
        margin-top: -1px;
    }
    color: ${({ $current }) => $current ? 'white' : colors.primaryColor};
    background-color: ${({ $current }) => $current ? colors.primaryColor : 'white'};

    &:hover, &:focus, &:active, &:visited {
        color: ${({ $current }) => $current ? 'white' : colors.primaryColor};
    }
`;

function NavTabs({ task }: IProps): JSX.Element {
    if (!task.showSharedAnswers) {
        return null;
    }
    const urlPath = window.location.pathname;
    return <Tabs>
        <LinkTab to={`/submitted-task/${task.id}`} $current={urlPath === (`/submitted-task/${task.id}`)}>
            {t('player.task-tabs.tab-my-answer')}
        </LinkTab>
        {task.showSharedAnswers && <LinkTab
            to={`/submitted-task/${task.id}/all-answers`}
            $current={urlPath === (`/submitted-task/${task.id}/all-answers`)}
        >
            <NoteIcon />
            {t('player.task-tabs.tab-all-answers')}
        </LinkTab>}
    </Tabs>;
}

export default NavTabs;
